import { ApplicationRoutes } from '../constants/appRoutes';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { Layout } from '../components/layout/layout';
import { AppRoles } from '../constants/appRoles';

const schedulingRoles = [AppRoles.CleaningAdmin, AppRoles.Admin, AppRoles.Manager];

export const SchedulingRoutes: RouteItem = {
  text: 'Schedule',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: schedulingRoles,
  layout: <Layout containerProps={{ w: '100%' }} />,
  subItems: [
    {
      text: 'Calendar',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: schedulingRoles,
      path: ApplicationRoutes.scheduling.calendar,
      async lazy() {
        const component = await import('../features/scheduling/Calendar/Calendar');
        return { Component: component.Calendar };
      }
    },
    {
      text: 'Availability Dashboard',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: schedulingRoles,
      path: ApplicationRoutes.scheduling.availabilityDashboard,
      async lazy() {
        const component = await import('../features/scheduling/AvailabilityDashboard/AvailabilityDashboard');
        return { Component: component.AvailabilityDashboard };
      }
    }
  ]
};
